const ALL_SUBSCRIPTION_CASES_FACET = 'all subscription cases';
const WINE_PLAN_SUBSCRIPTION = 'wineplan';

const normalize = (value: string): string => value.trim().toLowerCase();

const hasSubscriptionCaseFacet = (casesValue: unknown): boolean => {
  if (Array.isArray(casesValue)) {
    return casesValue.some(value => typeof value === 'string' && normalize(value) === ALL_SUBSCRIPTION_CASES_FACET);
  }

  if (typeof casesValue === 'string') {
    const normalizedCases = normalize(casesValue);
    if (normalizedCases.includes(ALL_SUBSCRIPTION_CASES_FACET)) {
      return true;
    }

    return normalizedCases
      .split(',')
      .map(value => normalize(value))
      .includes(ALL_SUBSCRIPTION_CASES_FACET);
  }

  return false;
};

const hasWinePlanSubscriptionType = (schemeDetails: unknown): boolean => {
  if (!schemeDetails || typeof schemeDetails !== 'object') {
    return false;
  }

  const { subscriptionType } = schemeDetails as { subscriptionType?: unknown };
  return typeof subscriptionType === 'string' && normalize(subscriptionType) === WINE_PLAN_SUBSCRIPTION;
};

export const isSubscriptionCaseItem = (productLike: unknown): boolean => {
  if (!productLike || typeof productLike !== 'object') {
    return false;
  }

  const typedProduct = productLike as { cases?: unknown; schemeDetails?: unknown };
  return hasSubscriptionCaseFacet(typedProduct.cases) || hasWinePlanSubscriptionType(typedProduct.schemeDetails);
};
